/**
 * Per-status badge theme + icon for donation-form lifecycle statuses (Draft → Published →
 * Paused → Archived). Mirrors finance's `donationStatusBadge` so the colour + icon mapping
 * lives in one place, shared by the form list status column.
 */
export const formStatusTheme = {
    Draft: "neutral",
    Published: "green",
    Paused: "orange",
    Archived: "red",
};
export const formStatusIcon = {
    Draft: "ri-draft-line",
    Published: "ri-checkbox-circle-fill",
    Paused: "ri-pause-circle-fill",
    Archived: "ri-archive-fill",
};
